// Flattens Markdown into a single line of plain text, e.g. for truncated previews.
export function markdownToPlainText(markdown: string): string {
  return markdown
    .replace(/!?\[([^\]]*)\]\([^)]*\)/g, '$1') // links and images → their text
    .replace(/^\s{0,3}#{1,6}\s+/gm, '') // headings
    .replace(/^\s*(?:[-*+]|\d+[.)])\s+/gm, '') // list markers
    .replace(/^\s*>\s?/gm, '') // blockquotes
    .replace(/(\*\*|__|\*|_)(\S(?:.*?\S)?)\1/g, '$2') // bold / italic
    .replace(/\\([\\`*_{}[\]()#+\-.!>])/g, '$1') // escaped characters
    .replace(/\s+/g, ' ')
    .trim()
}
